import * as React from 'react';
import styles from './sidebar.module.css';
import { convertStringtoDollarString } from '../../../helpers/formathelper';
import { GetGoalTypeDisplayText } from '../../../helpers/goal.helper';
import { EllipsisText } from '../../../helpers/ellipsistext';

import { useLead } from '../../../contexts/lead/lead.context';
import { TScreenType } from '../../../models/screen-type';
import { useParams } from 'react-router';

export type TStateProps = {
	investorState?: any;
	screen: string;
};

export const SideBarComponent: React.FC<TStateProps> = (props: TStateProps) => {
	const { leadProfile } = useLead();

	const activeState = (subM: any) => {
		return props.screen === subM ? styles.active : styles.noactive;
	};

	return (
		<div className={styles.sideMenu}>
			<nav className={styles.sideMenuNavBar} role="navigation">
				<ul className={styles.rowFlex}>
					<li
						className={
							props.screen === 'about'
								? styles.active
								: styles.noactive
						}>
						<a className={styles.tabText}>
							{' '}
							1. Name
							<p className={styles.info}>
								<span>
									{(leadProfile.Investor.FirstName || leadProfile.Investor.LastName) && (
										<EllipsisText text={leadProfile.Investor.FirstName + ' ' + leadProfile.Investor.LastName} length={28} />
									)}
								</span>
							</p>
						</a>
					</li>
					<li className={activeState('investment_amount')}>
						<a className={styles.tabText}>
							{' '}
							2. Investment Amount
							<p className={styles.info}>
								<span>
									{(leadProfile.investmentInfo && leadProfile.investmentInfo.InvestmentAmount !== 0
											? `${convertStringtoDollarString(leadProfile.investmentInfo.InvestmentAmount)}`
											: '')}
								</span>
							</p>
						</a>
					</li>
					<li className={activeState('investment_reason')}>
						<a className={styles.tabText}>
							{' '}
							3. Investment Reason
							<p className={styles.info}>
								<span>
									{/* {leadProfile.investmentReason &&
										(leadProfile.investmentReason !== '-1'
											? GetGoalTypeDisplayText(
												leadProfile.investmentReason !== 'Retirement' ? leadProfile.investmentReason : '2',
											  )
											: '')} */}
											{leadProfile.investmentReason &&
										GetGoalTypeDisplayText(
											leadProfile.investmentReason !== 'Retirement' ? leadProfile.investmentReason : '2',
										  )}
								</span>
							</p>
						</a>
					</li>
				</ul>
			</nav>
		</div>
	);
};
